import React, { useEffect, useState } from "react";
import Select from "react-select";
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { Card, CardHeader, Col, Row } from "reactstrap";
import { MetaTags } from "react-meta-tags";
import './style.scss'
import UnitSizesService from "services/Admin/UnitSizesService";
import {unitPropertyOptions} from "Enums/fixedData"
import CancelModal from "components/CancelModal"
import InventoryService from "services/SalesDeveloper/InventoryService";
import { toast } from "react-toastify";
import { salesDeveloperPrefix } from "configs/routePrefix";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { useSelector } from "react-redux";

const Wirframe = ({history, location, match}) =>{
    const filter = useSelector(state => state.adminFilter)
    const developer_id = filter?.developer_id || localStorage.getItem('developer_id')
    const unitSizesService = new UnitSizesService()
    const inventoryService = new InventoryService()
    const [modal, setModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [submit, setSubmit] = useState(false)
    const [sheetColumnsOptions, setSheetColumnsOptions]= useState([])
    const [unitSizesOptions, setUnitSizesOptions]= useState([])
    const [unitPropertyOption, setUnitPropertyOption]= useState([...unitPropertyOptions])
    const [loadingSize, setLoadingSize]= useState(false)
    const [data, setData]= useState(location.state.props)
    const [errors, setErrors]= useState(location.state.props?.errors)
    const checkError = (data) => location.state.props?.errors?.includes(data)
    const AuthData = useSelector(state => state.Auth)
    const [compoundSystem, setCompoundSystem]= useState({
        label: 'Compound Name',
        value: 'Compound Name'
    })
    
    const [formData, setFormData]= useState({
        developer: AuthData.userId,
        compoundSheetColumns: null,
        buildingSystemInputs: null,
        compoundSheetColumns: null,
        delevery_status: '',
        compound: '',
        building: '',
        area: [{
            sheet: null,
            system: {label: "Built up Area", value: "built_up_area"}
        }],
        general: [{
            sheet: null,
            system: null
        }],
        other: null
    })

    useEffect(()=>{
        let columnsArr=[]
        if(!!data?.columns && data?.columns?.length > 0) {
            data?.columns[0]?.map((column, index)=> {
                if(typeof column === "string"){
                    columnsArr.push({
                        label: column,
                        value: index
                    })
                }
            })
        }
        setSheetColumnsOptions([...sheetColumnsOptions , ...columnsArr])
    },[])

    useEffect(()=>{
        unitSizesService.getDropDown().then(res=>{
            let sizes = res.data?.map(size=>{
                return{
                    label: size?.name?.en,
                    value: size.id
                }
            })
            setUnitSizesOptions(sizes)
            setLoadingSize(prev=> !prev)
        })
    },[])

    useEffect(()=>{
        if(!data.isAdd){
            let checkOther = []
            setFormData({
                developer: {
                    ...data.developer?.name,
                    label: data.developer?.name.en,
                    value: data.developer?.id
                },
                compound: data?.compound_details?.type,
                building: data?.building_status?.type,
                buildingSystemInputs: {
                    label: data.building_status?.sheet,
                    value: data.building_status?.sheet
                },
                compoundSheetColumns: {
                    label: data.compound_details?.sheet,
                    value: data.compound_details?.sheet
                },
                delevery_status: data?.building_status?.status,
                area: data?.areas?.map(area=>{
                    return {
                        sheet: {
                            label: area.sheet,
                            value: area.sheet
                        },
                        system: unitSizesOptions?.filter(res=> res.value === area?.system)[0],
                    }
                }),
                general: data?.general?.map(item=>{
                    return {
                        sheet: {
                            label: item.sheet,
                            value: item.sheet
                        },
                        system: {
                            label: unitPropertyOption?.filter(property=> property?.value === item?.system)[0]?.label,
                            value: item.system
                        },
                    }
                }),
                other: data.other?.map(item=>{
                    if(checkError(item)){
                        checkOther.push(item)
                    }
                    return{
                        label: item,
                        value: item,
                    }
                })
            })
            const shColumns = data?.columns[0]?.map((value,index) => {
                if(value !== data?.compound_details?.sheet &&
                    value !== data.building_status?.sheet &&
                    !data.other?.includes(value) && 
                    !data.general?.some((obj) => obj?.sheet === value) && 
                    !data?.areas?.some((obj) => obj?.sheet === value) && !!value){
                        return{
                            label: value,
                            value: index,
                        }
             }
            });
            setSheetColumnsOptions([...shColumns.filter(res=> !!res)])
            
            let updateUnitSizes = unitSizesOptions?.filter(size=> !data?.areas?.some((obj) => obj?.system === size?.value))
            setUnitSizesOptions(updateUnitSizes)
        }
    },[loadingSize])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    
    const handleValidSubmit = (e, v) => {
        setSubmit(true)
        
        const generalHasNull = formData?.general.some(obj => {
            return Object.values(obj).some(val => val === null);
        });
        const areaHasNull = formData?.general.some(obj => {
            return Object.values(obj).some(val => val === null);
        });
        if(!formData.building || !formData.compound || 
            (!formData.delevery_status && formData?.building !== "status_with_number") || 
            !formData.buildingSystemInputs || generalHasNull || areaHasNull || 
            (!formData.compoundSheetColumns && formData.compound !== 'single')){
                return
        }
        
        let reqData={
            name: data?.name,
            compound_details: {
                type: formData.compound,
                sheet: formData.compound === 'multi' ? formData.compoundSheetColumns?.label : ''
            },
            building_status:{
                type: formData.building,
                status: formData?.building !== "status_with_number" ? formData.delevery_status : null,
                sheet: formData.buildingSystemInputs?.label
            },
            areas: formData?.area?.map(item=>{
                return {
                    sheet: item.sheet?.label,
                    system: item.system?.label,
                }
            }),
            general: formData?.general?.map(item=>{
                return {
                    sheet: item.sheet?.label,
                    system: item.system?.value,
                }
            }),
            developer_id: formData.developer,
            other: !!formData?.other ? formData?.other?.map(item=> item?.label) : [],
        }
        if(data.isAdd){
            setLoading(true)
            inventoryService.create(reqData).then(res=>{
                if (res && res.status === SuccessCreated) {
                    setLoading(false)
                    toast.success("Sheet Added Successfully")
                    history.push(`${salesDeveloperPrefix}/compound/compound-list/${developer_id}`)
                } 
            })
        } else{
            if(errors.length == 0){
                setLoading(true)
                inventoryService.update(data.id, reqData).then(res=>{
                    if (res && res.status === SuccessOk) {
                        setLoading(false)
                        toast.success("Sheet Updated Successfully")
                        history.push(`${salesDeveloperPrefix}/compound/compound-list/${developer_id}`)
                } 
            })
            }
        } 
    }

    function removeError(res){
        if(!data?.isAdd && checkError(res)){
            let index = errors.indexOf(res);
            if (index !== -1) {
                errors.splice(index, 1);
            }
        }
    }

    return( <>
        <MetaTags>
          <title>Wirframe</title>
        </MetaTags>
        <div className='page-content px-3 wirframe'>
            <AvForm
                model={formData}
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v);
                }}>

                <Card className="p-4 mt-2">
                    <div>
                        <label>Compound Details</label>
                        <p className="text-muted" style={{borderBottom: "1px solid #dedede"}}>Description</p>
                        <Row>
                            <Col md={12} className='mb-3'>
                                <div onChange={e=> handleFieldChange(e)}>
                                    <label 
                                        for="multi" 
                                        className={submit && !formData.compound ? 'error ms-2' : 'ms-2'}>
                                        <input 
                                            className="me-2"
                                            type='radio' 
                                            name="compound"
                                            checked={formData.compound === 'multi'} 
                                            id="multi" 
                                            value='multi'
                                        />
                                        Multi Compounds
                                        <p className="text-muted mb-0 ms-4">Description</p>
                                    </label>
                                    
                                    <label for="single" 
                                        className={submit && !formData.compound ? 'error ms-5' : 'ms-5'}>
                                        <input
                                            className="me-2"
                                            type='radio' 
                                            name="compound" 
                                            checked={formData.compound === 'single'} 
                                            id="single" 
                                            value="single"  
                                        />
                                        single
                                        <p className="text-muted mb-0 ms-4">Description</p>
                                    </label>

                                </div>
                                {submit && !formData.compound && <span className="error font-size-12">This Field is Required</span>}
                            </Col>
                            {formData.compound == 'multi' && <Col md={6}>
                                <label className={checkError(formData.compoundSheetColumns?.label) || (submit && !formData.compoundSheetColumns) ? 'error' : ''}>
                                    your Sheet Columns
                                </label>
                                <Select
                                    placeholder={"Select"}
                                    options={sheetColumnsOptions}
                                    className={checkError(formData.compoundSheetColumns?.label) || (submit && !formData.compoundSheetColumns) ? 'error-border' : ''}
                                    onChange={(e) => {
                                        let options = sheetColumnsOptions?.filter(col=> col.label !== e.label)
                                        if(!!formData?.compoundSheetColumns){
                                            setSheetColumnsOptions([formData?.compoundSheetColumns, ...options])
                                        } else {
                                            setSheetColumnsOptions([...options])
                                        }
                                        
                                        // if(!formData.compoundSheetColumns){
                                        //     setSheetColumnsOptions([...options])
                                        // } else{
                                        //     if(errors?.includes(formData.compoundSheetColumns.label)){
                                        //         setSheetColumnsOptions([...options])
                                        //     } else{
                                        //         setSheetColumnsOptions([formData.compoundSheetColumns, ...options])
                                        //     }
                                        // }
                                        removeError(formData?.compoundSheetColumns?.label)
                                        setFormData({...formData, compoundSheetColumns: e})
                                    }}
                                    value={formData.compoundSheetColumns}
                                />
                                {submit && !formData.compoundSheetColumns && <p className="error font-size-12">This Field is Required</p>}
                            </Col>}
                            {/* {formData.compound !== 'single'  && <Col md={6}>
                                <label>System Inputs</label>
                                <Select value={compoundSystem} />
                            </Col>} */}
                        </Row>
                    </div>
                </Card>

                <Card className="p-4 mt-2">
                    <div>
                        <label>Building Status</label>
                        <p className="text-muted" style={{borderBottom: "1px solid #dedede"}}>Description</p>
                        <Row>
                            <Col md={12} className='mb-3'>
                                <div onChange={e=> handleFieldChange(e)}>
                                    <label for="number" className={submit && !formData.building ? 'error ms-2' : 'ms-2'}>
                                        <input 
                                            className="me-2"
                                            type='radio' 
                                            name="building"
                                            checked={formData.building === 'number'} 
                                            id="number" 
                                            value='number'
                                        />
                                        Number year/month
                                        <p className="text-muted mb-0 ms-4">Description</p>
                                    </label>
                                    
                                    <label for="status_with_number" className={submit && !formData.building ? 'error ms-5' : 'ms-5'}>
                                        <input
                                            className="me-2"
                                            type='radio' 
                                            name="building" 
                                            checked={formData.building === 'status_with_number'} 
                                            id="status_with_number" 
                                            value="status_with_number"  
                                        />
                                        Build status with year number
                                        <p className="text-muted mb-0 ms-4">Description</p>
                                    </label>

                                    <label for="date" className={submit && !formData.building ? 'error ms-5' : 'ms-5'}>
                                        <input
                                            className="me-2"
                                            type='radio'
                                            name="building" 
                                            checked={formData.building === 'date'} 
                                            id="date" 
                                            value="date"  
                                        />
                                        Date
                                        <p className="text-muted mb-0 ms-4">Description</p>
                                    </label>
                                </div>
                                {submit && !formData.building && <p className="error font-size-12">This Field is Required</p>}
                            </Col>
                            {!!formData?.building && formData?.building !== "status_with_number" && <Col md={6}>
                                <label className= {submit && !formData.delevery_status ? 'error' : ''}>Delivery Status</label>
                                <AvField
                                    placeholder="Enter"
                                    name="delevery_status"
                                    bsSize="lg"
                                    type="text"
                                    onChange={(e => handleFieldChange(e))}
                                    value={formData.delevery_status}
                                    className= {submit && !formData.delevery_status ? 'error-border' : ''}
                                />
                                {submit && !formData.delevery_status && <p className="error font-size-12">This Field is Required</p>}
                            </Col>}
                            {!!formData?.building && <Col md={6}>
                                <label className={checkError(formData.buildingSystemInputs?.label) || (submit && !formData.buildingSystemInputs) ? 'error' : ''}>
                                    System Inputs
                                </label>
                                <Select
                                    placeholder={"Select"}
                                    className={checkError(formData.buildingSystemInputs?.label) || (submit && !formData.buildingSystemInputs) ? 'error-border' : ''}
                                    options={sheetColumnsOptions}
                                    onChange={(e) => {
                                        let options = sheetColumnsOptions?.filter(col=> col.label !== e.label)
                                        if(!!formData?.buildingSystemInputs){
                                            setSheetColumnsOptions([formData?.buildingSystemInputs, ...options])
                                        } else {
                                            setSheetColumnsOptions([...options])
                                        }
                                        
                                        // if(!formData?.buildingSystemInputs){
                                        //     setSheetColumnsOptions([...options])
                                        // } else{
                                        //     if(errors?.includes(formData.buildingSystemInputs.label)){
                                        //         setSheetColumnsOptions([...options])
                                        //     } else{
                                        //         setSheetColumnsOptions([formData.buildingSystemInputs, ...options])
                                        //     }
                                        // }
                                        removeError(formData?.buildingSystemInputs?.label)
                                        setFormData({...formData, buildingSystemInputs: e})
                                    }}
                                    value={formData.buildingSystemInputs}
                                />
                                {submit && !formData.buildingSystemInputs && <p className="error font-size-12">This Field is Required</p>}
                            </Col>}
                        </Row>
                    </div>
                </Card>

                <Card className="p-4 mt-2">
                    <div>
                        <label>Area</label>
                        <p className="text-muted" style={{borderBottom: "1px solid #dedede"}}>Description</p>
                        {formData?.area?.map((item,index)=>{
                            return(
                            <Row key={index} className='mb-3'>
                                <Col md={6}>
                                    <label className={checkError(item?.sheet?.label) || (submit && !item.sheet) ? 'error' : ''}>
                                        your Sheet Columns
                                    </label>
                                    <Select
                                        placeholder={"Select"}
                                        options={sheetColumnsOptions}
                                        value={ item?.sheet}
                                        className={checkError(item?.sheet?.label) || (submit && !item.sheet) ? 'error-border' : ''}
                                        onChange={e => {
                                            const updatedAreas = formData.area?.map((offItem, offIndex) => {
                                                if (index === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        sheet: e
                                                    }
                                                }
                                            return offItem
                                            })
                                            let options = sheetColumnsOptions?.filter(col=> col.label !== e.label)
                                            
                                            if(!!item?.sheet){
                                                setSheetColumnsOptions([item?.sheet, ...options])
                                            } else{
                                                setSheetColumnsOptions([...options])
                                            }

                                            removeError(item?.sheet?.label)
                                            setFormData({ ...formData, area: [...updatedAreas] })
                                        }}
                                    />
                                    {submit && !item.sheet && <p className="error font-size-12">This Field is Required</p>}
                                </Col>
                                <Col md={5}>
                                    <label className={submit && !item.system ? 'error' : ''}>System Inputs</label>
                                    <Select
                                        placeholder={"Select"}
                                        options={unitSizesOptions}
                                        className={submit && !item.system ? 'error-border' : ''}
                                        value={item.system}
                                        isDisabled={index === 0 ? true : false}
                                        onChange={e => {
                                            const updatedAreas = formData.area?.map((offItem, offIndex) => {
                                                if (index === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        system: e
                                                    }
                                                }
                                            return offItem
                                            })
                                            setFormData({ ...formData, area: [...updatedAreas] })
                                            if(!!item.system){
                                                setUnitSizesOptions([item.system, ...unitSizesOptions?.filter(col=> col.label !== e.label)])
                                            } else {
                                                setUnitSizesOptions(unitSizesOptions?.filter(col=> col.label !== e.label))
                                            }
                                            
                                        }}
                                    />
                                    {submit && !item.system && <p className="error font-size-12">This Field is Required</p>}
                                </Col>
                                {index >=1 && <Col md={1} className='mb-0 mt-4'>
                                    <button style={{border: "none", padding: '.7rem'}}
                                        type='button'
                                        onClick={()=>{
                                            const update= formData.area?.filter((child, childIndex)=> index !== childIndex)
                                            setFormData({...formData, area: [...update]})
                                            if(!checkError(item?.sheet?.label) && !!item.sheet) setSheetColumnsOptions([item?.sheet, ...sheetColumnsOptions])
                                            if(!!item.system) setUnitSizesOptions([item.system, ...unitSizesOptions])
                                        }}>
                                        <i className="fa fa-trash font-size-16"></i>
                                    </button>
                                </Col>}
                            </Row>)
                        })}
                        <button 
                            className="w-100 p-3 mt-3 border-0"
                            type='button'
                            onClick={()=> setFormData({...formData, area: [...formData.area, {
                                sheet: null,
                                system: null
                            } ]}) }>
                                <i className="fa fa-plus me-2"></i>
                            Add New Area
                        </button>
                    </div>
                </Card>

                <Card className="p-4 mt-2">
                    <div>
                        <label>General</label>
                        <p className="text-muted" style={{borderBottom: "1px solid #dedede"}}>Description</p>
                        {formData?.general?.map((item,index)=>{
                            return(
                            <Row key={index} className='mb-3'>
                                <Col md={6}>
                                    <label className={checkError(item?.sheet?.label) || (submit && !item.sheet) ? 'error' : ''}>
                                        your Sheet Columns
                                    </label>
                                    <Select
                                        placeholder={"Name"}
                                        options={sheetColumnsOptions}
                                        className={checkError(item?.sheet?.label) || (submit && !item.sheet) ? 'error-border' : ''}
                                        value={ item?.sheet}
                                        onChange={e => {
                                            const updatedGeneral = formData.general?.map((offItem, offIndex) => {
                                                if (index === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        sheet: e
                                                    }
                                                }
                                            return offItem
                                            })
                                            let options = sheetColumnsOptions?.filter(col=> col.label !== e.label)
                                            
                                            if(!!item?.sheet){
                                                setSheetColumnsOptions([item?.sheet, ...options])
                                            } else{
                                                setSheetColumnsOptions([...options])
                                            }
                                            
                                            removeError(item?.sheet?.label)
                                            setFormData({ ...formData, general: [...updatedGeneral] })
                                        }}
                                    />
                                    {submit && !item.sheet && <p className="error font-size-12">This Field is Required</p>}
                                </Col>
                                <Col md={5}>
                                    <label className={submit && !item.system ? 'error' : ''}>System Inputs</label>
                                    <Select
                                        placeholder={"Name"}
                                        options={unitPropertyOption}
                                        value={item.system}
                                        className={submit && !item.system ? 'error-border' : ''}
                                        onChange={e => {
                                            const updatedGeneral = formData.general?.map((offItem, offIndex) => {
                                                if (index === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        system: e
                                                    }
                                                }
                                            return offItem
                                            })
                                            setFormData({ ...formData, general: [...updatedGeneral] })
                                            if(!!item.system){
                                                setUnitPropertyOption([item.system, ...unitPropertyOption?.filter(col=> col.label !== e.label)])
                                            } else {
                                                setUnitPropertyOption([...unitPropertyOption?.filter(col=> col.label !== e.label)])
                                            }
                                            
                                        }}
                                    />
                                    {submit && !item.system && <p className="error font-size-12">This Field is Required</p>}
                                </Col>
                                {index >=1 && <Col md={1} className='mb-0 mt-4'>
                                    <button style={{border: "none", padding: '.7rem'}}
                                    type='button'
                                        onClick={()=>{
                                            const update= formData.general?.filter((child, childIndex)=> index !== childIndex)
                                            setFormData({...formData, general: [...update]})
                                            if(!checkError(item?.sheet?.label) && !!item.sheet) setSheetColumnsOptions([item?.sheet, ...sheetColumnsOptions])
                                            if(!!item.system) setUnitPropertyOption([item.system, ...unitPropertyOption])
                                        }}>
                                        <i className="fa fa-trash font-size-16"></i>
                                    </button>
                                </Col>}
                            </Row>)
                        })}
                        <button 
                            className="w-100 p-3 mt-3 border-0"
                            type='button'
                            onClick={()=> setFormData({...formData, general: [...formData.general, {
                                sheet: null,
                                system: null
                            } ]}) }>
                                <i className="fa fa-plus me-2"></i>
                            Add New Column
                        </button>
                    </div>
                </Card>

                <Card className="p-4 mt-2">
                    <div>
                        <label>Others Inputs</label>
                        <p className="text-muted" style={{borderBottom: "1px solid #dedede"}}>Description</p>
                        <Row>
                            <Col md={12}>
                                <label className={formData.other?.filter(res=> checkError(res.label)).length > 0 ? 'error' : ''}>
                                    Others
                                </label>
                                <Select
                                    placeholder={"Multiple Select"}
                                    className={formData.other?.filter(res=> checkError(res.label)).length > 0 ? 'error-border' : ''}
                                    options={sheetColumnsOptions}
                                    onChange={(e, v) => {
                                        let opt = sheetColumnsOptions?.filter(col=> col.label !== v?.option?.label)
                                        sheetColumnsOptions?.map(val => {
                                            if(v?.action !== "remove-value"){
                                                setSheetColumnsOptions([...opt])
                                            } else{
                                                if(errors?.includes(v?.removedValue?.label)){
                                                    setSheetColumnsOptions([...opt])
                                                } else{
                                                    setSheetColumnsOptions([{label: v?.removedValue?.label, value: v?.removedValue?.label},...opt])
                                                }
                                            }
                                        })
                                        setFormData({...formData, other: e})
                                        removeError(v?.removedValue?.label)
                                    }}
                                    value={formData.other}
                                    isMulti={true}
                                />
                            </Col>
                        </Row>
                    </div>
                </Card>

                <Row className="mb-4 mt-2">
                    <Col md={8}>
                        <Col md={3}>
                            <button
                                type="button"
                                className="btn btn-light w-100 border-2 border-success text-success"
                                onClick={() => setModal(true)} >Cancel</button>
                        </Col>
                        <Col md={6}></Col>
                    </Col>
                    <Col md={2}></Col>
                    <Col md={2} className="d-flex flex-row-reverse ">
                        <button
                            type="submit"
                            className="btn btn-success w-100 "
                            disabled={loading ? true : false}
                        >
                            Submit
                        </button>
                    </Col>
                </Row>

            </AvForm>

            {modal && <CancelModal modal={modal}
                    setModal={setModal}
                    goBackHandler={() => {
                        history.goBack()
                    }}
                />}
        </div>
        
    </>)
}

export default Wirframe;